import React, { useState } from 'react';
import { sendEmailVerification } from 'firebase/auth';
import { firebaseAuth } from '../firebase';
import { theme } from '../theme';
import { AuthShell, AuthButton } from './LoginPage';
import { useAuth } from '../context/AuthContext';

export default function VerifyEmailPage() {
  const { user, signOut, reloadUser } = useAuth();
  const [info, setInfo]   = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy]   = useState(false);

  async function handleResend() {
    setInfo(''); setError('');
    setBusy(true);
    try {
      await sendEmailVerification(firebaseAuth.currentUser);
      setInfo('Verification email sent — check your inbox (and spam folder).');
    } catch (err) {
      setError(err.code === 'auth/too-many-requests'
        ? 'Too many requests. Please wait a few minutes and try again.'
        : 'Could not send email. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  async function handleCheckVerified() {
    setBusy(true);
    try {
      await reloadUser();
      // reloadUser() calls reload() + updates AuthContext state.
      // If emailVerified is now true, App.js re-renders past this page automatically.
      if (!firebaseAuth.currentUser?.emailVerified) {
        setError('Email not yet verified. Check your inbox and click the link.');
      }
    } catch {
      setError('Could not refresh status. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthShell title="Verify your email">
      <p style={{ color: theme.textMuted, fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>
        We sent a verification link to{' '}
        <strong style={{ color: theme.text }}>{user?.email}</strong>.
        Click the link in the email to activate your account.
      </p>

      {error && <p style={{ color: theme.danger, fontSize: 13, marginBottom: 12 }}>{error}</p>}
      {info  && <p style={{ color: theme.success, fontSize: 13, marginBottom: 12 }}>{info}</p>}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <AuthButton onClick={handleCheckVerified} type="button" disabled={busy}>
          {busy ? 'Checking…' : "I've verified my email"}
        </AuthButton>

        <button onClick={handleResend} disabled={busy} style={{
          background: 'none', border: `1px solid ${theme.border}`,
          borderRadius: 6, padding: '8px 16px', color: theme.textMuted,
          fontSize: 13, cursor: busy ? 'not-allowed' : 'pointer',
        }}>
          Resend verification email
        </button>

        <button onClick={signOut} style={{
          background: 'none', border: 'none', color: theme.textMuted,
          fontSize: 13, cursor: 'pointer', marginTop: 4,
        }}>
          Sign out
        </button>
      </div>
    </AuthShell>
  );
}
